import React, { useEffect, useState, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const navItems = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Business', href: '/#business' },
  { label: 'Investments', href: '/#investments' },
  { label: 'Journal', href: '/#journal' },
  { label: 'Contact', href: '/#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 24);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <header
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, zIndex: 60,
        backgroundColor: scrolled ? 'rgba(246,241,230,0.92)' : 'transparent',
        backdropFilter: scrolled ? 'blur(10px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(11,30,63,0.08)' : '1px solid transparent',
        transition: 'background-color 260ms ease, border-color 260ms ease, backdrop-filter 260ms ease',
      }}
    >
      <div className="container-x" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 84 }}>
        <Link to="/" style={{ textDecoration: 'none', color: 'var(--sm-navy)', display: 'flex', alignItems: 'baseline', gap: 10 }}>
          <span className="serif" style={{ fontSize: 22, letterSpacing: '0.02em', fontWeight: 600 }}>ES Investments</span>
          <span style={{ fontSize: 10, letterSpacing: '0.3em', color: 'var(--sm-gold)', textTransform: 'uppercase' }}>Management LLC</span>
        </Link>

        <nav style={{ display: 'flex', alignItems: 'center', gap: 36 }} className="nav-desktop">
          {navItems.map((item) => (
            <a key={item.href} href={item.href} className="link-underline"
               style={{ fontSize: 12, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--sm-navy)', textDecoration: 'none', fontWeight: 500 }}>
              {item.label}
            </a>
          ))}
        </nav>

        <button className="nav-mobile-toggle" onClick={() => setOpen(!open)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--sm-navy)', display: 'none' }}>
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div style={{ background: 'var(--sm-ivory)', borderTop: '1px solid rgba(11,30,63,0.08)', padding: '20px 28px' }}>
          {navItems.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setOpen(false)}
               style={{ display: 'block', padding: '14px 0', fontSize: 13, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--sm-navy)', textDecoration: 'none', borderBottom: '1px solid rgba(11,30,63,0.06)' }}>
              {item.label}
            </a>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 900px) {
          .nav-desktop { display: none !important; }
          .nav-mobile-toggle { display: inline-flex !important; }
        }
      `}</style>
    </header>
  );
}
